import Wrap from '../../components/Wrap';
import fetchGql, { gql } from '../../util/fetchGql';
import Hero, { HERO_FRAGMENT } from '../../components/Hero';
import Seo, { SEO_FRAGMENT } from '../../components/Seo';
import Prose from '../../components/Prose';
import PostContent, { POST_CONTENT_FRAGMENT } from '../../components/PostContent';

export default function Page ({ entry: { seo, hero, text, postContent } }) {
	return (
		<>
			<Seo seo={seo} />
			{hero.length && <Hero {...hero[0]} black />}
			<Wrap>
				{text && <Prose isPage>{text}</Prose>}
				{postContent && <PostContent postContent={postContent} />}
			</Wrap>
		</>
	);
}

export async function getStaticProps ({ params, ...ctx }) {
	const data = await fetchGql(gql`
        query Page ($slug: String) {
            entry (slug: [$slug]) {
                ... on page_default_Entry {
                    seo { ...Seo }
                    hero: banner { ...Hero }
                    text
                }
                ... on page_landingPage_Entry {
                    seo { ...Seo }
                    hero: banner { ...Hero }
                    postContent { ...PostContent }
                }
            }
        }
        ${SEO_FRAGMENT}
        ${HERO_FRAGMENT}
        ${POST_CONTENT_FRAGMENT}
	`, {
		slug: params.slug,
	}, ctx);

	return {
		notFound: data.entry === null,
		props: data,
	};
}

export async function getStaticPaths () {
	const data = await fetchGql(gql`{
        entries (section: "page") {
            slug
        }
    }`);

	return {
		paths: data.entries.map(e => ({ params: e })),
		fallback: 'blocking',
	};
}
